
export const alphabet = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];


export type edge = {
    id: number;
    v1: number;
    v2: number;
    weight: number;
    selected: boolean;
};

export type graph = {
    nVertices: number;
    nEdges: number;
    edges: edge[];
};

export function createAdjMatrix (g: graph){
    const matrix: number[][] = [];
    for (const link of g.edges){
        const v = link.v1;
        const w = link.v2;
        matrix[v][w] = link.weight;
        matrix[w][v] = link.weight;
    }
    

}

let pred = [];

export function connectivityCheck(g: graph, sel: number[]){
    if(sel.length == 0){
        return false;
    }
    const adj: number[][] = [];
    for (let i = 0; i < g.nVertices; i++){
        adj.push([]);
    }
    // create adjacency matrix for the selected subgraph
    for (let i = 0; i < sel.length; i++){
        const v1 = g.edges[sel[i]].v1;
        const v2 = g.edges[sel[i]].v2;
        adj[v1].push(v2);
        adj[v2].push(v1);
    }

    const origin = g.edges[sel[0]].v1;
    const visited: boolean[] = Array<boolean>();
    // Pre-populate array:
    for(let i = 0; i < g.nVertices; i++){
        visited.push(false);
    }
    // run dfs to check connectivity
    const s: number[] = [];
    visited[origin] = true;
    s.push(origin);
    while(s.length > 0){
        const v = s.pop();
        for(const adjV of adj[v])
        {
            if(!visited[adjV])
            {
                visited[adjV] = true;
                s.push(adjV);
            }
        }
    }

    let connected = true;
    for(let i = 0; i < visited.length; i ++){
        const inGraph = adj[i].length > 0;
        if (!visited[i] && inGraph){
            connected = false;
        }
    }
    return connected;
}


export function checkValidity(g: graph, sel: number[], origin: number, sink: number){
    const nodeCount: number[] = new Array(g.nVertices);
    nodeCount.fill(0);
    // fill nodeCount with counts for each node in the selected edges, index is node number

    for(let i = 0; i < sel.length; i ++){
        const index = sel[i];
        const v1 = g.edges[index].v1;
        const v2 = g.edges[index].v2;
        nodeCount[v1]++;
        nodeCount[v2]++;
    }
    const a = nodeCount[origin];
    const b = nodeCount[sink];
    const ones = (nodeCount.filter(e => e == 1)).length;
    const twos = (nodeCount.filter(e => e == 2)).length;
    const threes = (nodeCount.filter(e => e == 3)).length;
    const fours = (nodeCount.filter(e => e == 4)).length;
    const big = (nodeCount.filter(e => e > 4)).length;

    let ret: number;
    // one outgoing edge from origin and one incoming edge to sink
    const sourceToSink = (nodeCount[origin] == 1 && nodeCount[sink] == 1);
    // no edges have been selected
    const empty = sel.length == 0;
    // connected check via dfs 
    const connected = connectivityCheck(g, sel);
    // in and out cycle in path
    const inOutCycle = ones == 2 && fours == 2 && threes == 0 && big == 0;
    // cycle and with walking the same path twice 
    const cycle = (threes > 0) && (threes % 2 == 0);


    if (empty){ // nothing has been selected
        ret = 0;
        console.log("noch nichts ausgewählt");
        
    } else if (a == 0 || b == 0){ // either origin or sink are not visited
        ret = 1
        console.log("du den start oder endpunkt nicht zu besuchen");
        
    } else if (!connected){ // selected edges are not conneted
        ret = 2;
        console.log("dein Weg scheint nicht verbunden zu sein");
        
    } else if (twos == sel.length && a == 2 && b == 2){ // one cycle containing source and waypoint -> roundtrip
        ret = 3;
        console.log("dein Weg ist ein zyklus");
        
    } else if (twos == sel.length){ // one cycle missing either source or waypoint -> roundtrip 
        ret = 4;
        console.log("dein weg ist ein zyklus");
        
    } else if (cycle || inOutCycle){ // cycle somwhere in the path
        ret = 5;
        console.log("du besuchst einen Ort mehrmals");
        
    } else if (ones > 2){ // tree
        ret = 6;
        console.log("du scheinst mehrere endpunkte zu haben");
    
    } else if (threes > 0 || fours > 0 || big > 0){ // something weird with a cycle
        ret = 7;
        console.log("du besuchst einen ort mehrmals");
        
    } else if (!sourceToSink){ // start or end node wrong
        ret = 8;
        console.log("dein start und ziel scheint nicht zu stimmen");
        
    } else { // correct
        ret = 9;
    }

    return ret;
}


// checks if roundtrip from origin to origin via waypoint is correct 
export function checkRoundtrip(g: graph, sel: number[], origin: number, waypoint: number){
    let countOrigin = 0;
    let countWP = 0;
    
    for (let i = 0; i < sel.length; i++){
        const index = sel[i];
        const v1 = g.edges[index].v1;
        const v2 = g.edges[index].v2;
        if (v1 == origin || v2 == origin){
            countOrigin++;
        } else if (v1 == waypoint || v2 == waypoint){
            countWP++;
        }
    }
    const ret = countOrigin == 2 && countWP == 2;

    return ret;
} 

// check if the roundtrip is valid 
export function checkSimpleMushRoundtrip(g: graph, sel: number[], origin: number){
    let countOrigin = 0;

    for (let i = 0; i < sel.length; i++){
        const index = sel[i];
        const v1 = g.edges[index].v1;
        const v2 = g.edges[index].v2;
        if (v1 == origin || v2 == origin){
            countOrigin++;
        } 
    }
    const ret = countOrigin == 2;

    return ret;
}

// get the amount of mushrooms collected from the set of selected edges
export function getMushCount(g: graph, sel: number[], mushrooms: number[]): number{
    const nodes = new Set();
    let count = 0;
    for (let i = 0; i < sel.length; i++){
        const index = sel[i];
        const v1 = g.edges[index].v1;
        const v2 = g.edges[index].v2;
        nodes.add(v1);
        nodes.add(v2);
    }
    for (let i  = 0; i < mushrooms.length; i++){
        if (nodes.has(i)){
            count += mushrooms[i];
        }
    }
    return count;
}


// gets the edge numbers of the edges involved in the result path
export function getResultEdges (g: graph, path: number[]): number[] {
    const resultEdges: number[] = [];

    for (let i = 0; i < path.length - 1; i++){
        const start = path[i];
        const end = path[i+1];
        for (let j = 0; j < g.edges.length; j++){
            if ((g.edges[j].v1 == start && g.edges[j].v2 == end) || (g.edges[j].v1 == end && g.edges[j].v2 == start)){
                resultEdges.push(g.edges[j].id)
                break;
            }
        }
    }
    return resultEdges;
}

// perform dijkstra on a graph to get shortest path from origin to sink (returns length of shortest path)
export function dijkstra (g: graph, origin: number, sink: number, ): number {
    const optimized: boolean[] = new Array(g.nVertices).fill(false);
    const matrix: number[][] = [];
    for (let i = 0; i < g.nVertices; i++){
        const temp = [];
        for(let j = 0; j < g.nVertices; j++){
            temp.push(0);
        }
        matrix.push(temp);
    }
    for (let i  = 0; i < g.nEdges; i++){
        const v = g.edges[i].v1;
        const w = g.edges[i].v2;
        matrix[v][w] = g.edges[i].weight;
        matrix[w][v] = g.edges[i].weight;
    }
    const distances: number[] = new Array(g.nVertices).fill(Number.POSITIVE_INFINITY);
    const predecessors: number[] = new Array(g.nVertices);
    distances[origin] = 0;
    while (optimized.filter(function(x: boolean): boolean{return !x}).length != 0) {
        let v: number;
        let min: number = Number.POSITIVE_INFINITY;
        let i = 0;
        for (const dist of distances) {
            if (dist <= min && !optimized[i]) {
                v = i;
                min = dist;
            }
            i++;
        }
        optimized[v] = true;
        for (let j  = 0; j < matrix[v].length; j++) {
            if (matrix[v][j] !== 0 && v !== j) {
                if (distances[v] + matrix[v][j] < distances[j]) {
                    distances[j] = distances[v] + matrix[v][j];
                    predecessors[j] = v;
                }
            }
        }
    }
    pred = predecessors;
    return distances[sink];
}

// get the actual order of the shortest path
export function getShortestPath(g: graph, origin: number, sink: number) {
    const reversePath = [];
    const path = [];
    let current = sink;
    reversePath.push(sink)
    while (current != origin){
        const prev = pred[current];
        reversePath.push(prev);
        current = prev;
    }
    for (let i = reversePath.length - 1; i >= 0; i --){
        path.push(reversePath[i]);
    } 
    return path;
}

// returns the nodes of the shortest path by letters
export function getSPALpha(path: number[]){
    const alphaPath = [];
    for (let i = 0; i < path.length; i++){
        alphaPath.push(alphabet[path[i]]);
    }
    return alphaPath;
}


export function getAllShortestPaths(g: graph, origin: number){
    const paths = new Set();
    for (let i = 0; i < g.nVertices; i++){
        if (i == origin){
            continue;
        }
        dijkstra(g, origin, i);
        const curr = getShortestPath(g, origin, i);
        paths.add(curr);
    }
    
    return paths;
}

export function createAdj(g: graph){
    const adj = [];
    for (let i = 0; i < g.nVertices; i ++){
        adj.push([]);
    }
    for (let i = 0; i < g.nEdges; i ++){
        const v1 = g.edges[i].v1;
        const v2 = g.edges[i].v2;
        adj[v1].push(v2);
        adj[v2].push(v1);
    }
    return adj;
}

// find the best roundtip from origin to origin collecting max amount of mushrooms in max minutes amount of time

export function dp(g: graph, adj: number[][], d: number[][], vis: Set<number>[][], currMinute: number, mushrooms: number[]){
    const row: number[] = new Array(g.nVertices);
    row.fill(0);
    // i: current vertice
    for(let i = 0; i < g.nVertices; i++){
        let currMax = 0;
        let maxNeigh = -1;
        let maxEdge = 0;
        // neigh: current neighbour of i 
        // j: index of neigh in adj matrix[i]
        for (let j = 0; j < adj[i].length; j++){
            const neigh = adj[i][j];
            
            let edgeWeight = 0;
            // get edge weight from graph
            for(let x = 0; x < g.nEdges; x ++ ){
                const v1 = g.edges[x].v1;
                const v2 = g.edges[x].v2;
                if ((v1 == i && v2 == adj[i][j]) || (v2 == i && v1 == adj[i][j])){
                    
                    edgeWeight = g.edges[x].weight;
                    break;
                }
            }

            if (currMinute - edgeWeight < 0 || edgeWeight == 0 ){
                continue;
            }

            const prev = vis[currMinute - edgeWeight][neigh];
            const found = prev.has(i);
            // for(let k = 0; k < prev.length; k++){
            //     if (prev[k] == i){
            //         found = true;
            //         break;
            //     }
            // }
            if (prev.size == 0 || found){
                continue;
            }
            if (d[currMinute - edgeWeight][neigh] + mushrooms[i] > currMax){
                maxNeigh = neigh;
                maxEdge = edgeWeight;
                currMax = d[currMinute - edgeWeight][neigh] + mushrooms[i];
            }
        }

        row[i] = currMax;
        if (currMax > 0){
            
            for ( const item of vis[currMinute -  maxEdge][maxNeigh].values() ){
                vis[currMinute][i].add(item);
            }
            vis[currMinute][i].add(maxNeigh);
            
        }

    }

    return row;
}

export function mushroomTrip(g: graph, adj: number[][], origin: number, maxMinutes: number, mushrooms: number[], visited: Set<number>[][]){
    const d: number[][] = [];
    // const visited: boolean[] = Array<boolean>();
    // Pre-populate array:
    for (let i = 0; i <= maxMinutes; i ++){
        const a = new Array(g.nVertices);
        a.fill(0);
        d.push(a);
        visited[i] = new Array(g.nVertices);
    }
    
    for(let i = 0; i < g.nVertices; i++){
        // visited.push(false);
        for (let j = 0; j <= maxMinutes; j ++){
            visited[j][i] = new Set();
        }
    }

    visited[0][origin].add(-1);
    d[0][origin] = mushrooms[origin];
    for (let i = 1; i <= maxMinutes; i ++){
        d[i] = dp(g, adj, d, visited, i, mushrooms);
    }
    let maxMush = 0;
    let maxMin = 0;
    let maxVer = 0;
    for (let i = 0; i <= maxMinutes; i ++){
        for (let j = 0; j <=  g.nVertices; j ++ ){
            if (d[i][j] > maxMush){
                maxMush = d[i][j];
                maxMin = i;
                maxVer = j;
            }
        }
        
    }
    // console.log(maxMush);
    // console.log(visited[maxMin][maxVer]);
    // console.log(maxVer);
    const solutionSet = visited[maxMin][maxVer];
    solutionSet.delete(-1);
    solutionSet.add(maxVer);
    const sol: number[] = [];
    for(const item of solutionSet){
        sol.push(item);
    }
    sol.push(maxMush);

    return sol;
}


// formats input edges in path order and outputs nicely formated string
export function formatPath(g: graph, edgeNumbers: number[], origin: number, sink: number): string{
    let formated = "";
    const numNodes = [];
    const alphaNodes = [];

    numNodes.push(origin);
    let current = origin;
    
    while(current != sink){
        for (let i = 0; i < edgeNumbers.length; i++){
            if(edgeNumbers[i] < g.nEdges){
                const one = g.edges[edgeNumbers[i]].v1;
                const two = g.edges[edgeNumbers[i]].v2;
                if (current == one){
                    numNodes.push(two);
                    current = two;
                    edgeNumbers[i] = g.nEdges;
                    break;
                } else if (current == two){
                    numNodes.push(one);
                    current = one;
                    edgeNumbers[i] = g.nEdges;
                    break;
                }
            }
        }
        
    }
    for (let i = 0; i < numNodes.length; i++){
        alphaNodes.push(alphabet[numNodes[i]]);
    }

    for (let i = 0; i < alphaNodes.length -1 ; i++){
        formated += alphaNodes[i];
        formated += " \u2014 "
    }
    formated += alphaNodes[alphaNodes.length - 1];
    
    return formated;
    
}



